import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const coreValues = [
  {
    icon: 'ri-shield-check-line',
    title: 'Trust',
    desc: 'We commit to transparent and consistent quality across every partnership and delivery.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Expertise',
    desc: 'Deep technical knowledge and hands-on field experience across diverse industries drive our strength.',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Reach',
    desc: 'We turn your overseas business ambitions into reality through our proven global network.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Innovation',
    desc: 'We continuously push the boundaries of technology to deliver better solutions for our clients.',
  },
];

export default function AboutEn() {
  const leftAnim = useScrollAnimation();
  const rightAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  return (
    <section id="about" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: Text */}
          <div
            ref={leftAnim.ref}
            className={`transition-all duration-700 ${leftAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-8 h-[2px] bg-[#E8650A]"></span>
              <span className="text-xs font-semibold text-[#E8650A] uppercase tracking-widest whitespace-nowrap">Company Overview</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2530] mb-8 leading-tight">
              We&apos;re not just a supplier —<br />
              <span className="text-[#E8650A]">we&apos;re your true partner.</span>
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6 text-[15px]">
              Fixcope is a comprehensive technology solution company built on cutting-edge technology and global partnerships. We span industrial machine vision inspection, overseas medical equipment supply, micro detachable-head camera development, and international business consulting.
            </p>
            <p className="text-gray-600 leading-relaxed text-[15px]">
              With extensive hands-on industry experience and verified global partnerships, we solve complex technical and business challenges quickly and reliably. Beyond product supply, Fixcope is dedicated to being a true partner in your growth journey.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <button
                onClick={() => {
                  const el = document.querySelector('#contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-6 py-3 bg-[#E8650A] text-white rounded-lg text-sm font-semibold hover:bg-[#C95508] transition-all whitespace-nowrap cursor-pointer"
              >
                Partner with Us
              </button>
              <button
                onClick={() => {
                  const el = document.querySelector('#business');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg text-sm font-semibold hover:border-[#E8650A] hover:text-[#E8650A] transition-all whitespace-nowrap cursor-pointer"
              >
                View Business Areas
              </button>
            </div>
          </div>

          {/* Right: Core Values */}
          <div
            ref={rightAnim.ref}
            className={`grid grid-cols-1 sm:grid-cols-2 gap-5 transition-all duration-700 ${rightAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            {coreValues.map((v, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl bg-[#FEF3E8] border border-[#FDE8CC] hover:border-[#E8650A]/30 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#E8650A]/10 mb-4">
                  <i className={`${v.icon} text-xl text-[#E8650A]`}></i>
                </div>
                <h4 className="text-sm font-bold text-[#1A2530] mb-2 whitespace-nowrap">{v.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
